import { Badge } from "@chakra-ui/react";
import {
  getProposalStatusAndCustomStatusConsignado,
  getProposalStatusColorConsignado,
} from "./getProposalStatusAndCustomStatus";


export enum ProposalStatus {
  PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  PENDING_FORMALIZATION = "PENDING_FORMALIZATION",
  PENDING_REFORMALIZATION = "PENDING_REFORMALIZATION",
  PENDING_BANK_ANALYSIS = "PENDING_BANK_ANALYSIS",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PENDING_USER_REVIEW = "PENDING_USER_REVIEW",
  SELFSERVICE = "SELFSERVICE",
  PAYED = "PAYED",
  CANCELED = "CANCELED",
  IN_CANCELLATION = "IN_CANCELLATION",
  CANCELED_BY_CLIENT = "CANCELED_BY_CLIENT",
  REPROVED = "REPROVED",
  ERROR_CREATE_BIOMETRIC_VALIDATION = "ERROR_CREATE_BIOMETRIC_VALIDATION",
  AGUARDANDO_VALIDADE_LEILAO = "AGUARDANDO_VALIDADE_LEILAO",
}

interface StatusRendererProps {
  status: ProposalStatus;
  customStatus?: string | null | undefined;
  fontSize?: string;
  /** Sobrescreve mb/mt (default: mb=4, mt=2) com o mesmo valor nos dois. */
  my?: number | string;
  /** Limita a largura pra forçar o texto a quebrar em mais de uma linha. */
  maxW?: string;
}

interface StatusMapProperties {
  color: string;
  text: string;
}
const statusMap: Record<ProposalStatus, StatusMapProperties> = {
  [ProposalStatus.PAYED]: {
    color: "green.500",
    text: "Pago",
  },
  [ProposalStatus.CANCELED]: {
    color: "red.500",
    text: "Cancelado",
  },
  [ProposalStatus.REPROVED]: {
    color: "red.500",
    text: "Reprovado",
  },
  [ProposalStatus.IN_CANCELLATION]: {
    color: "yellow.500",
    text: "Cancelamento em andamento",
  },
  [ProposalStatus.CANCELED_BY_CLIENT]: {
    color: "red.500",
    text: "Cancelado pelo cliente",
  },
  [ProposalStatus.SELFSERVICE]: {
    color: "secondary",
    text: "Self service",
  },
  [ProposalStatus.PENDING_CONFIRMATION]: {
    color: "gray.500",
    text: "Aguardando Finalizar Digitação",
  },
  [ProposalStatus.PENDING_FORMALIZATION]: {
    color: "secondary",
    text: "Aguardando Formalização",
  },
  [ProposalStatus.PENDING_REFORMALIZATION]: {
    color: "yellow.500",
    text: "Aguardando Refazer Formalização",
  },
  [ProposalStatus.PENDING_BANK_ANALYSIS]: {
    color: "yellow.500",
    text: "Aguardando Análise Banco",
  },
  [ProposalStatus.PENDING_PAYMENT]: {
    color: "orange.500",
    text: "Aguardando Pagamento",
  },
  [ProposalStatus.PENDING_USER_REVIEW]: {
    color: "purple.500",
    text: "Erro na Criação da Proposta",
  },
  [ProposalStatus.ERROR_CREATE_BIOMETRIC_VALIDATION]: {
    color: "red.500",
    text: "Falha no Link da Formalização",
  },
  [ProposalStatus.AGUARDANDO_VALIDADE_LEILAO]: {
    color: "blue.500",
    text: "Aguardando Validade do Leilão",
  }
};

export function getStatusProps(status: string): StatusMapProperties {
  return statusMap[ProposalStatus[status as keyof typeof ProposalStatus]];  
}

export function StatusRenderer({ status, customStatus, fontSize = "sm", my, maxW }: StatusRendererProps) {
  const { text = "Desconhecido" } = statusMap[status] || {};
  const color = getProposalStatusColorConsignado(status, customStatus) ?? "gray.500";
  return (
    <Badge
      bg={color}
      color="white"
      mb={my ?? 4}
      mt={my ?? 2}
      px={3}
      py={1}
      display="flex"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      whiteSpace="normal"
      maxW={maxW}
      mx="auto"
      fontSize={fontSize}
      fontWeight="bold"
      fontFamily="Lexend Deca"
      borderRadius="md"
    >
        {getProposalStatusAndCustomStatusConsignado(status, customStatus!) || text}
    </Badge>
  );
}
